import { render, staticRenderFns } from "./TextSettingsMobile.vue?vue&type=template&id=0497c5fd&scoped=true&"
import script from "./TextSettingsMobile.vue?vue&type=script&lang=ts&"
export * from "./TextSettingsMobile.vue?vue&type=script&lang=ts&"
import style0 from "./TextSettingsMobile.vue?vue&type=style&index=0&id=0497c5fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0497c5fd",
  null
  
)

export default component.exports